const actionTypes={
    //actions for login, sign up, log out
    LOGIN_SUCCESS: 'LOGIN_SECCESS',
    LOGIN_FAIL: 'LOGIN_FAIL',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAIL: 'REGISTER_FAIL',
    LOGOUT: 'LOGOUT',

    //actions for order
    SET_ORDER_SUCCESS: 'SET_ORDER_SUCCESS',
    SET_ORDER_FAIL: 'SET_ORDER_FAIL',

    SET_CART_SUCCESS: "SET_CART_SUCCESS",
    SET_CART_FAIL: "SET_CART_FAIL",

    //user
    GET_CURRENT:"GET_CURRENT",
    UPDATE_INFOR: "UPDATE_INFOR",

    //products
    GET_PRODUCTS:"GET_PRODUCT"

}

export default actionTypes